<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->
<template>
  <div class="bg-gray-50">
    <!-- 顶部导航 -->
    <header class=" rounded-lg h-16 bg-white shadow-sm z-50">
      <div class="mx-auto px-4 h-full flex items-center justify-between">
        <div class="flex items-center space-x-8">
          <h1 class="text-xl font-bold ">数据概览</h1>
          <div class="flex items-center space-x-4">
            <a-radio-group v-model="currentModule" class="flex" @change="handleModuleChange">
              <a-radio-button value="QC">千川标准数据</a-radio-button>
              <a-radio-button value="QY">千川全域数据</a-radio-button>
              <a-radio-button value="SXT">随心推数据</a-radio-button>
            </a-radio-group>
          </div>
        </div>
        <div class="flex items-center">
          <a-dropdown>
            <a-button class="!rounded-button whitespace-nowrap">
              优先展示数据
            </a-button>
            <template #overlay>
              <a-menu>
                <a-menu-item key="1" @click="handleSettingSelect('1')">优先展示千川标准数据</a-menu-item>
                <a-menu-item key="2" @click="handleSettingSelect('2')">优先展示千川全域数据</a-menu-item>
                <a-menu-item key="3" @click="handleSettingSelect('3')">优先展示随心推数据</a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </div>
    </header>
    <!-- 主体内容 -->
    <main>
      <div class="mx-auto py-6">
        <!-- 时间控制器 -->
        <div class="bg-white p-4 rounded-lg shadow-sm mb-6">
          <div class="flex items-center justify-between">
            <div class="flex items-center space-x-4">
              <a-select v-model="advertiser_id" placeholder="请选择账户" class="w-56">
                <a-select-option v-for="item in advertiserList" :key="item.advertiser_id" :value="item.advertiser_id">
                  {{ currentModule == 'SXT' ? item.aweme_name : item.advertiser_name }}
                </a-select-option>
              </a-select>
              <a-select v-model="marketing_goal" placeholder="营销场景" class="w-36">
                <a-select-option value="">全部场景</a-select-option>
                <a-select-option value="VIDEO_PROM_GOODS">推商品计划</a-select-option>
                <a-select-option value="LIVE_PROM_GOODS">推直播间计划</a-select-option>
              </a-select>
              <a-radio-group v-model="timeRange" class="flex" @change="handleTimeRangeChange">
                <a-radio-button value="1">今日</a-radio-button>
                <a-radio-button value="2">昨日</a-radio-button>
                <a-radio-button value="3">本周</a-radio-button>
                <a-radio-button value="4">上周</a-radio-button>
                <a-radio-button value="5">本月</a-radio-button>
                <a-radio-button value="6">上月</a-radio-button>
              </a-radio-group>
              <a-range-picker :ranges="{
                  '今日': [moment(), moment()],
                  '昨日': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                  '本周': [moment().startOf('week'), moment()],
                  '上周': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
                  '本月': [moment().startOf('month'), moment()],
                  '上月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                }" :value="range_date" class="w-64" :placeholder="['开始时间', '结束时间']" @change="handleRangeChange" />  
            </div>
            <div class="flex items-center space-x-4" style="position: relative;">
              <a-statistic-countdown :title="deadtitle" :value="deadline"
                style="margin-left: 50px;position: absolute;right: 130px;" @finish="onFinish" v-if="timer_status"/>

                
              <a-switch checked-children="刷新开启" un-checked-children="刷新关闭" :checked="timer_status"  @change="changeTimerStatus" style="margin-left: 10px;position: absolute;right: 30px;"/>

              <!-- <a-button type="primary" class="!rounded-button" @click="refreshData">
                刷新数据
              </a-button> -->
            </div>
          </div>
        </div>
        <!-- 核心指标 -->
        <div class="grid grid-cols-5 gap-4 mb-6">
          <div v-for="(metric, index) in coreMetrics" :key="index" class="bg-white p-4 rounded-lg shadow-sm">
            <div class="text-gray-500 mb-2">{{ metric.name }}</div>
            <div class="text-2xl font-bold">{{ metric.value }}</div>
            <div :class="['text-sm mt-2', metric.trend > 0 ? 'text-green-500' : 'text-red-500']">
              {{ metric.trend > 0 ? '+' : '' }}{{ metric.trend }}%
            </div>
          </div>
        </div>
        <!-- 趋势图表 -->
        <div class="grid grid-cols-2 gap-6 mb-6">
          <div class="bg-white p-4 rounded-lg shadow-sm">
            <div class="flex items-center justify-between mb-4">
              <h3 class="text-lg font-medium">本月转化趋势</h3>
              <div class="flex items-center space-x-4">
                <a-select v-model="trendMetric1" style="width: 120px" class="mr-4">
                  <a-select-option value="stat_cost">消耗</a-select-option>
                  <a-select-option value="pay_order_amount">成交订单金额</a-select-option> 
                  <a-select-option value="pay_order_count">成交订单数</a-select-option> 
                </a-select>
                <a-select v-model="trendMetric2" style="width: 120px">
                  <a-select-option value="stat_cost">消耗</a-select-option>
                  <a-select-option value="pay_order_amount">成交订单金额</a-select-option> 
                  <a-select-option value="pay_order_count">成交订单数</a-select-option> 
                </a-select>
              </div>
            </div>
            <a-spin :spinning="chartLoading">
              <div ref="chart1" class="w-full h-80"></div>
            </a-spin>
          </div>
          <div class="bg-white p-4 rounded-lg shadow-sm">
            <div class="flex items-center justify-between mb-4">
              <h3 class="text-lg font-medium">账号分布</h3>
              <a-select v-model="distributionMetric" style="width: 120px">
                <a-select-option value="stat_cost">消耗</a-select-option>
                <a-select-option value="pay_order_amount">成交订单金额</a-select-option>
                <a-select-option value="pay_order_count">成交订单数</a-select-option>
              </a-select>
            </div>
            <div ref="chart2" class="w-full h-80"></div>
          </div>
        </div>
        <!-- TOP 10 排行榜 -->
        <div class="grid grid-cols-2 gap-6 mb-6" v-if="false">
          <!-- 计划排行 -->
          <div class="bg-white p-4 rounded-lg shadow-sm">
            <div class="flex items-center justify-between mb-4">
              <h3 class="text-lg font-medium">计划排行 TOP 10</h3>
              <a-radio-group v-model="planRankingType" class="flex">
                <a-radio-button value="goods">推商品计划</a-radio-button>
                <a-radio-button value="live">推直播计划</a-radio-button>
              </a-radio-group>
            </div>
            <a-table :columns="planRankColumns" :data-source="planRankData" :pagination="false" size="small" />
          </div>
          <!-- 商品排行 -->
          <div class="bg-white p-4 rounded-lg shadow-sm">
            <div class="flex items-center justify-between mb-4">
              <h3 class="text-lg font-medium">商品排行 TOP 10</h3>
              <a-select v-model="productRankMetric" style="width: 120px">
                <a-select-option value="sales">销售额</a-select-option>
                <a-select-option value="volume">销量</a-select-option>
                <a-select-option value="roi">ROI</a-select-option>
              </a-select>
            </div>
            <a-table :columns="productRankColumns" :data-source="productRankData" :pagination="false" size="small" />
          </div>
        </div>
        <!-- 详细数据表格 -->
        <div class="bg-white p-4 rounded-lg shadow-sm">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-medium">账户总览</h3>
            <div class="flex items-center space-x-4">
              <a-input-search v-model="searchText" placeholder="搜索账户" class="w-64" @search="onSearch" />
              <a-button type="primary" class="!rounded-button" @click="downloadData">
                刷新数据
              </a-button>
            </div>
          </div>
          <a-table :columns="balanceColumns" :rowKey="(record,index) => index" :data-source="balanceList" :pagination="{ pageSize: 10 }" >

            <div class="aweme" slot="aweme" slot-scope="text">

              <div v-if="currentModule == 'SXT'" style="display: flex;">
                <div class="aweme-left">
                  <img slot="aweme_avatar" class="videoimg" :src="text.aweme_avatar" v-if="text.aweme_avatar" />
                </div>
                <div class="aweme-right">
                  <div class="aweme-title">{{ text.aweme_name }}</div>
                  <div class="aweme-name">抖音号：{{ text.aweme_id }}</div>
                </div>
              </div>
              <div v-else>
                <div class="aweme-title">{{ text.advertiser_name }}</div>
              </div>
            </div>

            <a-tag slot="status" color="green" slot-scope="text" v-if="text == '1'">授权正常</a-tag>
            <a-tag slot="status" color="red" v-else>授权失效</a-tag>


            <a-tag slot="is_valid" color="green" slot-scope="text" v-if="text == '1'">账户正常</a-tag>
            <a-tag slot="is_valid" color="red" v-else>账户失效</a-tag>

          </a-table>

        </div>
      </div>
    </main>
  </div>
</template>
<script>
import { message } from 'ant-design-vue'
import * as echarts from 'echarts'
import { qcApi, requestHttp } from '@utils/index'
import moment from 'moment'; 
export default {
  name: 'Workplace',
  
  components: {
  },

  data() {
    return {
      chartLoading: false,
      timeRange: '5',
      range_date: null,

      searchText: '',
      selectedAccount: '',
      currentModule: localStorage.getItem('preferredModule') || 'QC',
      marketing_goal: '',

      trendMetric1: 'stat_cost',
      trendMetric2: 'pay_order_amount',
      distributionMetric: 'stat_cost',
      planRankingType: 'goods',
      productRankMetric: 'sales',

      // 图表实例
      myChart1: null,
      myChart2: null,

      // 核心指标数据
      coreMetrics: [
        { name: '总消耗', value: '-', trend: '-',key:'stat_cost' },
        { name: '总成交金额', value: '-', trend: '-',key:'pay_order_amount' },
        { name: 'ROI', value: '-', trend: '-',key:'prepay_and_pay_order_roi' },
        { name: '总成交订单数', value: '-', trend: '-',key:'pay_order_count' },
        { name: '千次展示费用', value: '-', trend: '-',key:'cpm_platform' }
      ],

      // 表格配置
      balanceColumns: [
        { title: '账户信息', width: 300, key: 'aweme', scopedSlots: { customRender: 'aweme' }, align: 'center' },
        { title: '千川户ID', dataIndex: 'advertiser_id', key: 'advertiser_id' },
        { title: '账户总余额', dataIndex: 'total_balance_abs', key: 'total_balance_abs' },
        { title: '账户有效余额', dataIndex: 'general_balance_valid', key: 'general_balance_valid' },
        { title: '共享钱包通用可用余额', dataIndex: 'share_wallet_general_valid', key: 'share_wallet_general_valid' },
        { title: '授权状态', dataIndex: 'status', key: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '账户状态', dataIndex: 'is_valid', key: 'is_valid', scopedSlots: { customRender: 'is_valid' }, align: 'center' },
      ],
      balanceList: [],
      // 表格数据
      advertiserList: [],
      advertiser_id: '',

      // 排行榜配置
      planRankColumns: [
        { title: '排名', dataIndex: 'rank', key: 'rank', width: 70 },
        { title: '计划名称', dataIndex: 'name', key: 'name' },
        { title: '消耗', dataIndex: 'cost', key: 'cost', align: 'right' },
        { title: '转化成交金额', dataIndex: 'amount', key: 'amount', align: 'right' },
        { title: 'ROI', dataIndex: 'roi', key: 'roi', align: 'right' }
      ],

      productRankColumns: [
        { title: '排名', dataIndex: 'rank', key: 'rank', width: 70 },
        { title: '商品信息', dataIndex: 'name', key: 'name' },
        { title: '销售额', dataIndex: 'sales', key: 'sales', align: 'right' },
        { title: '销量', dataIndex: 'volume', key: 'volume', align: 'right' },
        { title: 'ROI', dataIndex: 'roi', key: 'roi', align: 'right' }
      ],

      planRankData: [],
      productRankData: [],

      toploading:false,
      report:{},
      deadline: Date.now() + 1000 * 31,
      deadtitle: '倒计时',
      timer_status:true,
    }
  },

  computed: {
    chartOptions() {
      return {
        trend: {
          animation: false,
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: [this.getTrendMetricName(this.trendMetric1), this.getTrendMetricName(this.trendMetric2)],
            bottom: '0'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '40px',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: this.report.xData || []
          },
          yAxis: [{
            type: 'value',
            name: '数值',
            axisLabel: {
              formatter: (value) => {
                if (this.trendMetric1.includes('roi') || this.trendMetric2.includes('roi')) {
                  return value;
                }
                return `￥${value}`;
              }
            }
          }],
          series: [{
            name: this.getTrendMetricName(this.trendMetric1),
            data: this.report.y1Data || [],
            type: 'line',
            smooth: true
          }, {
            name: this.getTrendMetricName(this.trendMetric2),
            data: this.report.y2Data || [],
            type: 'line',
            smooth: true
          }]
        },
        distribution: {
          animation: false,
          tooltip: {
            trigger: 'item',
            formatter: (params) => {
              let value;
              if (this.distributionMetric === 'pay_order_count') {
                value = `${params.value} 个`;
              } else {
                value = `¥${params.value.toFixed(2)}`;
              }
              return `${params.name}\n${this.getDistributionMetricName(this.distributionMetric)}: ${value}\n占比: ${params.percent}%`;
            }
          },
          legend: {
            orient: 'vertical',
            right: 10,
            top: 'center',
            type: 'scroll',
            formatter: (name) => {
              if (name.length > 12) {
                return name.substring(0, 12) + '...';
              }
              return name;
            }
          },
          series: [{
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true,
              formatter: (params) => {
                const name = params.name.length > 8 ? params.name.substring(0, 8) + '...' : params.name;
                return `${name}\n${params.percent}%`;
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: this.report.circleData || []
          }]
        }
      }
    }
  },

  mounted() {
    
    // 加载优先展示设置
    const preferredModule = localStorage.getItem('preferredModule')
    if (preferredModule) {
      this.currentModule = preferredModule
    }
    const today = moment();
    this.range_date = [moment().startOf('month').format('YYYY-MM-DD'), today.format('YYYY-MM-DD')];
    // 获取广告主列表
    this.getAdvertiserList()
    this.getReport();
    this.getIndexEchart(); // 获取趋势图数据
    this.getIndexCircle(); // 获取账号分布数据
    this.initCharts()
    window.addEventListener('resize', this.handleResize)
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
    this.disposeCharts()
  },

  watch: {
    range_date: {
      handler(newVal) {
        if (newVal && newVal[0] && newVal[1]) {
          // this.getReport();
          this.$nextTick(() => {  // 等待DOM更新
            this.getIndexEchart();
            this.getIndexCircle();
            this.initCharts();    // 重新初始化图表
          });
        }
      },
      deep: true
    },
    trendMetric1: {
      handler() {
        this.getIndexEchart();
        this.initCharts();    // 重新初始化图表
      }
    },
    trendMetric2: {
      handler() {
        this.getIndexEchart();
        this.initCharts();    // 重新初始化图表
      }
    },
    advertiser_id: {
      handler() {
        this.getReport();
        this.getIndexEchart();
        this.getIndexCircle();
        this.initCharts();    // 重新初始化图表
      }
    },
    currentModule: {
      handler() {
        this.getAdvertiserList();
        this.getReport();
        this.disposeCharts(); // 先销毁图表
        this.$nextTick(() => {  // 等待DOM更新
          this.getIndexEchart();
          this.getIndexCircle();
          this.initCharts();    // 重新初始化图表
        });
      }
    },
    distributionMetric: {
      handler() {
        this.getIndexCircle();
        this.initCharts();    // 重新初始化图表
      }
    },
    marketing_goal: {
      handler() {
        this.getReport();
        this.getIndexEchart();
        this.getIndexCircle();
        this.initCharts();    // 重新初始化图表
      }
    }
  },

  methods: {
    moment,
    onFinish() {
      if(!this.timer_status){
        return
      }
      this.$message.loading({ content: '刷新中...' });
      this.deadtitle = '正在刷新...';
      this.refreshData();
      setTimeout(() => {
        this.$message.success({ content: '刷新成功!', duration: 2 });
        this.deadtitle = '倒计时'
        this.deadline = Date.now() + 1000 * 31
      }, 1000);
    },
    changeTimerStatus(){
      this.timer_status = !this.timer_status
      if(this.timer_status){
        this.deadline = Date.now() + 1000 * 31
      }
    },
    handleTimeRangeChange(e) {
      if (!e.target.value) return; 
      const today = moment();
      const value = e.target.value;
      switch (value) {
        case '1': // 今日
          this.range_date = [today.format('YYYY-MM-DD'), today.format('YYYY-MM-DD')];
          break;
        case '2': // 昨日
          this.range_date = [moment().subtract(1, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')];
          break;
        case '3': // 本周
          this.range_date = [
            moment().startOf('week').format('YYYY-MM-DD'),
            today.format('YYYY-MM-DD')
          ];
          break;
        case '4': // 上周
          this.range_date = [
            moment().subtract(1, 'week').startOf('week').format('YYYY-MM-DD'),
            moment().subtract(1, 'week').endOf('week').format('YYYY-MM-DD')
          ];
          break;
        case '5': // 今月
          this.range_date = [
            moment().startOf('month').format('YYYY-MM-DD'),
            today.format('YYYY-MM-DD')
          ];
          break;
        case '6': // 上月 
          this.range_date = [
              moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
              moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
          ];
          break;
        default:
          break;
      }
      this.timeRange = e.target.value;
      console.log(value,this.range_date)
      // 更新日期后执行报表获取
      if (this.range_date[0] && this.range_date[1]) {
        this.getReport();
      }
    },
    async getAdvertiserList() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_ALL_ADVERTISER}`,
        method: 'POST',
        params: {
          type: this.currentModule == 'SXT'?'SXT':'QC',
          is_show:1
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) return;
      let dataSource = [{ advertiser_id: '', advertiser_name: '全部账户',aweme_name: '全部抖音号', aweme_id: '', aweme_avatar: '' }];
      data.list.forEach(function (item) {
        dataSource.push(item)
      })
      this.advertiserList = dataSource;
      this.advertiser_id = dataSource[0].advertiser_id;
      this.balanceList = data.list;
      //获取数据汇总
      
    },
    async getReport() { 
      this.toploading = true
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QC_ADVERTISER_REPORT_GET_ALL}`,
        method: 'POST',
        params: {
          source:'QC',
          type: this.currentModule, 
          advertiser_id: this.advertiser_id,
          marketing_goal: this.marketing_goal,
          start_date: this.range_date[0] ? this.range_date[0] : '',
          end_date: this.range_date[1] ? this.range_date[1] : '',
        },
      });
      this.toploading = false
      if (code == 0) { 
        return;
      }
      if (!data) return;
      if(this.currentModule == 'QY'){
        this.coreMetrics.forEach(item => {
          if(item.key =='stat_cost'){
            item.value = data.total_pay_amount_str||0.00
            item.trend = data.total_pay_amount_str_trend
          }else if(item.key =='pay_order_amount'){
            item.value = data.estimated_total_commission_str||0.00
            item.trend = data.estimated_total_commission_str_trend
          }else if(item.key =='prepay_and_pay_order_roi'){
            item.value = data.valid_total_pay_amount_str||0.00 
            item.trend = data.valid_total_pay_amount_str_trend
          }else if(item.key =='pay_order_count'){
            item.value = data.valid_count||0
            item.trend = data.valid_count_trend
          }else if(item.key =='cpm_platform'){  
            item.value = data.total_pay_order_coupon_amount_for_roi2	||0.00
            item.trend = data.total_pay_order_coupon_amount_for_roi2_trend
            item.name = '整体成交智能优惠券'
          }
        })
      }else{
        this.coreMetrics.forEach(item => {
          if(item.key =='stat_cost'){
            item.value = data.total_pay_amount_str||0.00
            item.trend = data.total_pay_amount_str_trend
          }else if(item.key =='pay_order_amount'){
            item.value = data.estimated_total_commission_str||0.00
            item.trend = data.estimated_total_commission_str_trend
          }else if(item.key =='prepay_and_pay_order_roi'){
            item.value = data.valid_total_pay_amount_str||0.00
            item.trend = data.valid_total_pay_amount_str_trend
          }else if(item.key =='pay_order_count'){
            item.value = data.valid_count||0
            item.trend = data.valid_count_trend
          }else if(item.key =='cpm_platform'){  
            item.value = data.cpm_platform||0.00
            item.trend = data.cpm_platform_trend
            item.name = '千次展示费用'
          }
        })
      }
      this.report = data;
    },
    initCharts() {
      this.disposeCharts()
      this.$nextTick(() => {  // 确保DOM已更新
        if (this.$refs.chart1) {
          this.myChart1 = echarts.init(this.$refs.chart1)
          this.myChart1.setOption(this.chartOptions.trend)
        }
        if (this.$refs.chart2) {
          this.myChart2 = echarts.init(this.$refs.chart2)
          this.myChart2.setOption(this.chartOptions.distribution)
        }
      })
    },

    updateCharts() {
      this.$nextTick(() => {  // 确保数据更新后再更新图表
        if (this.myChart1) {
          this.myChart1.setOption(this.chartOptions.trend)
        }
        if (this.myChart2) {
          this.myChart2.setOption(this.chartOptions.distribution)
        }
      })
    },

    disposeCharts() {
      if (this.myChart1) {
        this.myChart1.dispose()
        this.myChart1 = null
      }
      if (this.myChart2) {
        this.myChart2.dispose()
        this.myChart2 = null
      }
    },

    handleResize() {
      if (this.myChart1) this.myChart1.resize()
      if (this.myChart2) this.myChart2.resize()
    },

    getDistributionData() {
      const dataMap = {
        cost: [
          { value: 156789, name: '服装' },
          { value: 98765, name: '鞋靴' },
          { value: 78654, name: '包包' },
          { value: 65432, name: '配饰' },
          { value: 45678, name: '美妆' }
        ],
        orderAmount: [
          { value: 256789, name: '服装' },
          { value: 178765, name: '鞋靴' },
          { value: 148654, name: '包包' },
          { value: 95432, name: '配饰' },
          { value: 75678, name: '美妆' }
        ],
        orderCount: [
          { value: 3567, name: '服装' },
          { value: 2876, name: '鞋靴' },
          { value: 2154, name: '包包' },
          { value: 1832, name: '配饰' },
          { value: 1567, name: '美妆' }
        ]
      }
      return dataMap[this.distributionMetric] || []
    },

    refreshData() {
      this.getReport();
      this.getIndexEchart();
      this.getIndexCircle();
      this.initCharts();    // 重新初始化图表
    },

    exportReport() {
      message.success('报表导出成功')
    },

    onSearch(value) {
      console.log('搜索:', value)
    },

    downloadData() {
      this.getAdvertiserList();
      message.success('刷新成功')
    },

    handleSettingSelect(key) {
      const settingMap = {
        '1': 'QC',
        '2': 'QY',
        '3': 'SXT'
      }
      const moduleType = settingMap[key]
      this.currentModule = moduleType
      if (moduleType) {
        localStorage.setItem('preferredModule', moduleType)
        message.success(`已设置优先展示${this.getModuleDisplayName(moduleType)}`)
      }
    },
    handleModuleChange(e){
      let moduleType = e.target.value
      this.currentModule = moduleType
      if (moduleType) {
        localStorage.setItem('preferredModule', moduleType)
        message.success(`已设置优先展示${this.getModuleDisplayName(moduleType)}`)
      }
    }, 
    getModuleDisplayName(moduleType) {
      const displayNames = {
        QC: '千川标准数据',
        QY: '千川全域数据',
        SXT: '随心推数据'
      }
      return displayNames[moduleType] || moduleType
    },

    // 获取趋势图数据
    async getIndexEchart() {
      this.chartLoading = true;  // 开始加载
      try {
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.GET_INDEX_ECHART}`,
          method: 'POST',
          params: {
            advertiser_id: this.advertiser_id,
            y1: this.trendMetric1,
            y2: this.trendMetric2,
            type: this.currentModule,
            marketing_goal:this.marketing_goal,
            start_date: this.range_date[0],
            end_date: this.range_date[1],
          },
        });
        if (code == 0) {
          this.$message.error(msg);
          return;
        }
        if (!data) return;
        this.report = {
          ...this.report,
          xData: data.xData || [],
          y1Data: data.y1Data || [],
          y2Data: data.y2Data || []
        };
        this.updateCharts();
      } catch (error) {
        console.error('获取趋势图数据失败:', error);
        this.$message.error('获取趋势图数据失败');
      } finally {
        this.chartLoading = false;  // 结束加载
      }
    },

    // 获取指标名称
    getTrendMetricName(metric) {
      const metricNames = {
        'stat_cost': '消耗',
        'pay_order_amount': '成交订单金额',
        'prepay_and_pay_order_roi': 'ROI',
        'pay_order_count': '成交订单数',
        'cpm_platform': '千次展示费用'
      };
      return metricNames[metric] || metric;
    },

    // 获取账号分布数据
    async getIndexCircle() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_INDEX_CIRCLE}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          type: this.currentModule,
          marketing_goal: this.marketing_goal,
          metric: this.distributionMetric,
          start_date: this.range_date[0],
          end_date: this.range_date[1],
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) return;

      // 处理数据，过滤掉数值为0的数据
      // const validData = data.filter(item => {
      //   const value = parseFloat(item[this.distributionMetric]);
      //   return value > 0;
      // });

      // 格式化数据为饼图所需格式
      const circleData = data.map(item => {
        const value = parseFloat(item[this.distributionMetric]);
        return {
          name: item.advertiser_name || '未知账户',
          value: this.formatValue(value)
        };
      });

      this.report = {
        ...this.report,
        circleData
      };
      this.updateCharts();
    },

    // 格式化数值
    formatValue(value) {
      if (this.distributionMetric === 'pay_order_count') {
        return parseInt(value);
      }
      // 对于金额，保留两位小数并转换为数字类型
      return parseFloat(parseFloat(value).toFixed(2));
    },

    // 获取指标名称
    getDistributionMetricName(metric) {
      const metricNames = {
        'stat_cost': '消耗',
        'pay_order_amount': '成交订单金额',
        'pay_order_count': '成交订单数'
      };
      return metricNames[metric] || metric;
    },

    handleRangeChange(dates) {
      if (dates && dates.length === 2) {
        this.range_date = [
          moment(dates[0]).format('YYYY-MM-DD'),
          moment(dates[1]).format('YYYY-MM-DD')
        ];
        this.timeRange = '';  // 清空时间范围选择
        this.getReport();
      }
    },
  }
}
</script>

<style lang="less" scoped>
:deep(.ant-input-search-button) {
  border-radius: 0 4px 4px 0;
}

:deep(.ant-input-affix-wrapper) {
  border-radius: 4px 0 0 4px;
}

:deep(.ant-table-thead > tr > th) {
  background: #f5f7fa;
}

.mainContent {
  background: none !important;
  padding-bottom: 50px !important;
}

.aweme{
  display: flex;
}

.aweme-right {
  padding-left: 30px;
  text-align: left;
  padding-left: 10px;
  padding-top: 10px;
  .aweme-title {
    color: #000;
    font-weight: bold;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 200px;
  }
}
.videoimg {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  margin-top: 5px;
}
/deep/ .ant-statistic-content{
  font-size: 14px !important;
  font-weight: bold;
}
</style>
